import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { ChevronLeft } from 'lucide-react';
import SubmitTab from './components/SubmitTab';
import DashboardTab from './components/DashboardTab';

export default function SentimentAnalysis() {
  const navigate = useNavigate();
  const [tab, setTab] = useState('submit');

  return (
    <div className="min-h-screen bg-gray-50 py-6 px-3" style={{ fontFamily: "'Mulish', sans-serif" }}>
      <div className="max-w-full mx-auto">
        <header className="flex flex-col gap-4 px-4 py-3 bg-white rounded-lg shadow-sm mx-4 md:flex-row md:items-center md:justify-between">
          <div className="flex flex-col gap-3 md:flex-row md:items-center md:gap-8">
            <div className="flex items-center gap-2">
              <button
                onClick={() => navigate('/home')}
                className="flex items-center gap-1.5 text-secondary hover:text-secondaryDark transition-colors py-1.5 px-3 rounded-md hover:bg-gray-100"
                aria-label="Back to home"
              >
                <ChevronLeft size={18} />
              </button>
              <div className="flex items-center gap-2">
                <span className="font-bold text-slate-800 tracking-tight">Financial Sentiment Analysis</span>
              </div>
            </div>

            <nav className="flex flex-wrap gap-1">
              {[
                { id: 'submit', label: 'Analyze Article' },
                { id: 'dashboard', label: 'Live Dashboard' },
              ].map(t => (
                <button
                  key={t.id}
                  onClick={() => setTab(t.id)}
                  className={`px-4 py-2 rounded-lg text-sm font-medium transition-colors ${
                    tab === t.id
                      ? 'bg-secondaryLight text-white'
                      : 'text-slate-500 hover:text-slate-700 hover:bg-slate-100'
                  }`}
                >
                  {t.label}
                </button>
              ))}
            </nav>
          </div>

        </header>

        <main className="mt-4 mx-4 overflow-y-auto">
          {tab === 'submit' && <SubmitTab />}
          {tab === 'dashboard' && <DashboardTab />}
        </main>
      </div>
    </div>
  );
}
